module.exports = __webpack_public_path__ + "assets/pdf/Abhishek_Raj.48d3da17.pdf";